import { assertIsNumberOrNull } from '../../../../helpers/numberHelpers';
import { UnitWallElementFormModel } from '../../quote-or-design-form/units/heatLoss/unitWallElementFormModel';

export type CreateUpdateUnitWallElementDto = {
  wallElementId: number | null;
  displayIndex: number;
  name: string;
  wallThermalTransmittance: number | null;
  windowThermalTransmittance: number | null;
  doorThermalTransmittance: number | null;
  defaultExternalAirTemperatureInDegreesCelsius: number | null;
};

export const mapUnitWallElementFormModelToDto = (
  formModel: UnitWallElementFormModel,
  displayIndex: number,
): CreateUpdateUnitWallElementDto => ({
  wallElementId: formModel.wallElementId,
  displayIndex,
  name: formModel.name,
  wallThermalTransmittance: assertIsNumberOrNull(formModel.wallThermalTransmittance),
  windowThermalTransmittance: assertIsNumberOrNull(formModel.windowThermalTransmittance),
  doorThermalTransmittance: assertIsNumberOrNull(formModel.doorThermalTransmittance),
  defaultExternalAirTemperatureInDegreesCelsius: assertIsNumberOrNull(
    formModel.defaultExternalAirTemperatureInDegreesCelsius,
  ),
});
